import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { User, Sparkles, ShoppingBag, ArrowRight, Info } from "lucide-react";
import { KD9LogoHorizontal, KD9Watermark } from "@/components/KD9Logo";
import ThemeToggle from "@/components/ThemeToggle";

const ROLES = [
  {
    id: "user",
    title: "USUARIO (CLIENTE)",
    desc: "Quiero acceder a estudios, consultas personalizadas y comprar en la tienda.",
    icon: User,
    accent: "#0D47A1",
  },
  {
    id: "consultor",
    title: "CONSULTOR",
    desc: "Quiero ofrecer mis servicios como consultor en la plataforma.",
    icon: Sparkles,
    accent: "#4B0082",
  },
  {
    id: "creador",
    title: "CREADOR",
    desc: "Quiero vender mis productos en la tienda y llegar a más personas.",
    icon: ShoppingBag,
    accent: "#A67C00",
  },
];

const SelectRole = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen" style={{ background: "var(--kd9-bg)" }} data-testid="select-role-page">
      <KD9Watermark size={680} opacity={0.04} className="absolute -right-40 top-20" />
      <KD9Watermark size={520} opacity={0.04} className="absolute -left-32 bottom-10" />

      <header className="relative z-10 flex items-center justify-between p-6 lg:p-8">
        <Link to="/"><KD9LogoHorizontal size={38} /></Link>
        <ThemeToggle />
      </header>

      <main className="relative z-10 max-w-5xl mx-auto px-6 lg:px-10 pt-6 pb-20">
        <div className="text-center mb-12 kd9-fade-up">
          <h1 className="font-cinzel kd9-gold-text text-3xl md:text-5xl tracking-[0.08em] mb-4">
            SELECCIONA TU ROL EN KD9
          </h1>
          <p
            className="font-cormorant italic text-xl"
            style={{ color: "var(--kd9-text-soft)" }}
          >
            Esto nos ayudará a personalizar tu experiencia.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ROLES.map((r, i) => (
            <div
              key={r.id}
              className={`kd9-card p-8 text-center cursor-pointer kd9-fade-up kd9-delay-${i + 1}`}
              onClick={() => {
                const map = { user: "cliente", consultor: "consultor", creador: "creador" };
                navigate(`/post-register/${map[r.id]}`);
              }}
              data-testid={`role-card-${r.id}`}
            >
              <div
                className="mx-auto w-20 h-20 rounded-full flex items-center justify-center mb-6"
                style={{
                  background: `${r.accent}22`,
                  border: `1px solid ${r.accent}66`,
                  boxShadow: `0 0 30px ${r.accent}33`,
                }}
              >
                <r.icon size={32} style={{ color: "var(--kd9-gold)" }} />
              </div>
              <h3 className="font-cinzel kd9-gold-text text-xl tracking-[0.16em] mb-4">
                {r.title}
              </h3>
              <p
                className="font-cormorant text-base mb-6 min-h-[64px]"
                style={{ color: "var(--kd9-text-soft)" }}
              >
                {r.desc}
              </p>
              <button className="kd9-btn-outline w-full py-3 rounded-xl text-[11px] flex items-center justify-center gap-2">
                Continuar <ArrowRight size={14} />
              </button>
            </div>
          ))}
        </div>

        <div
          className="mt-10 flex items-center justify-center gap-2 text-sm font-mont"
          style={{ color: "var(--kd9-text-soft)" }}
        >
          <Info size={14} style={{ color: "var(--kd9-gold)" }} />
          Podrás{" "}
          <span style={{ color: "var(--kd9-gold)" }}>cambiar tu rol</span>
          {" "}más adelante desde tu perfil.
        </div>
      </main>
    </div>
  );
};

export default SelectRole;
